"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var createPalette_1 = __importDefault(require("@material-ui/core/styles/createPalette"));
// eslint-disable-next-line no-restricted-imports
var colors_1 = require("@material-ui/core/colors");
var colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
var OFF_BLACK = "#0B0B0B";
exports.createPalette = function (_a) {
    if (_a === void 0) { _a = {}; }
    var _b = _a.type, type = _b === void 0 ? "dark" : _b, options = __rest(_a, ["type"]);
    return createPalette_1.default(__assign(__assign({}, options), { type: type, primary: __assign({ main: "#0074E4" }, options.primary), secondary: __assign(__assign({}, (type === "dark"
            ? { main: "#393939", contrastText: colors_1.common.white }
            : { main: "#E6E6E6", contrastText: OFF_BLACK })), options.secondary), error: __assign({ main: "#DE3341" }, options.error), success: __assign({ main: "#0B873A" }, options.success), warning: __assign({ main: "#FFA640", contrastText: OFF_BLACK }, options.warning), info: __assign({ main: "#6C5BB7" }, options.info), divider: options.divider || type === "dark"
            ? colorManipulator_1.fade(colors_1.common.white, 0.18)
            : colorManipulator_1.fade(colors_1.common.black, 0.12), background: __assign({ default: type === "dark" ? OFF_BLACK : colors_1.common.white, paper: type === "dark" ? "#232323" : "#F2F2F2" }, options.background), text: __assign({ primary: type === "dark" ? colors_1.common.white : OFF_BLACK, secondary: type === "dark" ? colorManipulator_1.fade(colors_1.common.white, 0.5) : colorManipulator_1.fade(OFF_BLACK, 0.6) }, options.text), action: __assign({ hover: type === "dark" ? colorManipulator_1.fade(colors_1.common.white, 0.18) : colorManipulator_1.fade(colors_1.common.black, 0.12), hoverOpacity: type === "dark" ? 0.18 : 0.12 }, options.action) }));
};
//# sourceMappingURL=createPalette.js.map